import { render, staticRenderFns } from "./ViewEvent.vue?vue&type=template&id=1e7f5896&"
import script from "./ViewEvent.vue?vue&type=script&lang=js&"
export * from "./ViewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports